import React, { memo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useWOpsAdminAccess } from '@/hooks/useWOpsAdminAccess';
import { LoadingSpinner } from './LoadingSpinner';

const ALLOWED_PATH_PREFIXES = [
  '/tracker/admin/w-ops/',
  '/auth',
  '/login',
  '/reset-password',
  '/pending-approval',
  '/privacy-policy',
  '/privacy',
  '/terms',
];

const WAPL_ADMIN_DASHBOARD = '/tracker/admin/w-ops/overview';

function isPathAllowed(pathname: string): boolean {
  return ALLOWED_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

export const WaplAdminGuard = memo(({ children }: { children: React.ReactNode }) => {
  const { canAccessWOpsAdminExtras, loading } = useWOpsAdminAccess();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (canAccessWOpsAdminExtras && !isPathAllowed(location.pathname)) {
    return <Navigate to={WAPL_ADMIN_DASHBOARD} replace />;
  }

  return <>{children}</>;
});

WaplAdminGuard.displayName = 'WaplAdminGuard';
